export default __webpack_public_path__ + "static/media/work-sans-v11-latin-regular.6817b7a5.woff2";